//
// http://gitlab.qtang.net/luolj/hbgj-api/blob/master/desc.md
//
import md5 from 'blueimp-md5'
import getCommonParams from '@/utils/getCommonRequestParams'


function generateSid(keys, obj, toUpper = true) {
  let s = keys.map(k => (obj[k])).join('')
  let e = md5(s + '/2g!q^l&$5')
  let sid = [9, 13, 10, 20, 11, 26, 17, 12].map(i => (e[i])).join('')
  return toUpper ? sid.toUpperCase() : sid
}

export default {
  getCommonParams,
  generateSid
}



// WEBPACK FOOTER //
// ./src/request/transformers/hbgj-api.js